<template>
  <div
    v-click-outside="$_dropdownClose"
    class="user-avatar"
  >
    <div
      class="user-avatar_image"
      :style="{backgroundImage: image ? 'url(' + image + ')' : 'url(' + require('@/assets/image/avatar.svg') + ')'}"
      @click="$_onClick()"
    />
    <transition mode="out-in">
      <div
        v-if="isActived"
        class="user-avatar_dropdown-menu"
      >
        <div
          v-for="(item,itemIndex) in itemList"
          :key="itemIndex"
          class="user-avatar_dropdown-menu-item"
          @click="$_btnClick(item.value)"
        >
          {{ $t(item.text) }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "UserAvatar",
  directives: {
    ClickOutside,
  },
  props: {
    image: {
      type: String,
      default: "",
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    isActived: false,
  }),
  methods: {
    $_onClick() {
      this.isActived = !this.isActived;
    },
    $_dropdownClose() {
      this.isActived = false;
    },
    $_btnClick($event) {
      this.$emit("btn-click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/user-avatar";
</style>